import BackButton from "./BackButton";

const BackNavigationBar = ({
  ariaLabel,
  backLabel,
  children,
  className = "",
  contentClassName = "",
  onBack,
  right,
  showBackLabel = false,
  subtitle,
  subtitleClassName = "",
  title,
  titleClassName = "",
}) => {
  const hasContent = children || title || subtitle;

  return (
    <div
      className={[
        "top-0 z-10 mb-3 flex min-h-[76px] items-center justify-between rounded-lg bg-white px-4 py-3 md:px-6",
        className,
      ].join(" ")}
    >
      <BackButton
        ariaLabel={ariaLabel || backLabel}
        label={showBackLabel ? backLabel : undefined}
        onClick={onBack}
      />

      <div className={["min-w-0 flex-1 px-3 text-center", contentClassName].join(" ")}>
        {children ||
          (hasContent && (
            <>
              {subtitle && (
                <p
                  className={[
                    "truncate text-sm text-gray-500",
                    subtitleClassName,
                  ].join(" ")}
                >
                  {subtitle}
                </p>
              )}
              {title && (
                <h1
                  className={[
                    "truncate text-2xl font-sf-semibold text-[#1358CB]",
                    titleClassName,
                  ].join(" ")}
                >
                  {title}
                </h1>
              )}
            </>
          ))}
      </div>

      {right || <div className="size-[42px] shrink-0" aria-hidden="true" />}
    </div>
  );
};

export default BackNavigationBar;
